import { useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PromoBanner from "@/components/PromoBanner";
import Books from "@/components/Books";
import Manifesto from "@/components/Manifesto";
import Blog from "@/components/Blog";
import InstagramFeed from "@/components/InstagramFeed";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { LangProvider } from "@/i18n/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PAY_TEXT = {
  es: { activated: "Suscripción premium activada. La tesis completa ya está disponible en su artículo de la bitácora.", canceled: "Pago cancelado. No se realizó ningún cargo.", pending: "No pudimos confirmar el pago. Si lo completaste, recarga la página en unos segundos." },
  en: { activated: "Premium subscription activated. The full thesis is now available in its logbook article.", canceled: "Payment canceled. No charge was made.", pending: "We could not confirm the payment. If you completed it, reload the page in a few seconds." },
  pt: { activated: "Assinatura premium ativada. A tese completa já está disponível em seu artigo no diário.", canceled: "Pagamento cancelado. Nenhuma cobrança foi feita.", pending: "Não conseguimos confirmar o pagamento. Se você o concluiu, recarregue a página em alguns segundos." },
  fr: { activated: "Abonnement premium activé. La thèse complète est disponible dans son article du journal.", canceled: "Paiement annulé. Aucun débit effectué.", pending: "Paiement non confirmé. Si vous l'avez terminé, rechargez la page dans quelques secondes." },
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    const canceled = params.get("canceled");
    if (!sessionId && !canceled) return;
    const lang = localStorage.getItem("alagrande_lang") || "es";
    const T = PAY_TEXT[lang] ?? PAY_TEXT.es;
    window.history.replaceState({}, "", window.location.pathname);
    if (canceled) {
      toast.info(T.canceled);
      return;
    }
    const tryGrant = async (attempts) => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const g = await axios.post(`${API}/premium/grant`, { session_id: sessionId });
          localStorage.setItem("alagrande_premium", g.data.premium_token);
          window.dispatchEvent(new Event("premium-changed"));
          toast.success(T.activated);
        } else if (attempts > 0) {
          setTimeout(() => tryGrant(attempts - 1), 2500);
        } else {
          toast.error(T.pending);
        }
      } catch {
        if (attempts > 0) setTimeout(() => tryGrant(attempts - 1), 2500);
      }
    };
    tryGrant(8);
  }, []);

  return (
    <LangProvider>
    <div className="min-h-screen bg-[#0D0D0E] text-[#F4F1EA] antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PromoBanner />
        <Books />
        <Manifesto />
        <Blog />
        <InstagramFeed />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
    </LangProvider>
  );
}

export default App;
